const EmployeeQueryType = {
    0: '전체',
    1: '사원번호',
    2: '운전자격번호',
    3: '기사명'
}

export default EmployeeQueryType